import type { FeatureRoute } from '../registry';
import { PublicDocumentPage } from './PublicDocumentPage';

// Public (unauthenticated) document views — legacy `#/views/{type}/{hash}`.
export const publicRoutes: FeatureRoute[] = [{ path: 'views/:type/:hash', element: <PublicDocumentPage /> }];
